<div class="app-container">
  <main class="main-content">
    <router-outlet />

    @if (appStore.globalLoading()) {
      <div class="loading-wrapper">
        <mat-spinner diameter="50" class="spinner" />
      </div>
    }
  </main>
</div>
